import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface DebugContextValue {
  /** Simule un citoyen déjà inscrit aux alertes citoyennes. */
  alreadySubscribed: boolean;
  setAlreadySubscribed: (value: boolean) => void;
  /** SSO actif : l'accès sans compte reste possible. */
  sso: boolean;
  setSso: (value: boolean) => void;
  /** Le citoyen détient une carte citoyenne vérifiée (identité verrouillée). */
  hasCard: boolean;
  setHasCard: (value: boolean) => void;
}
const DebugContext = createContext<DebugContextValue>({
  alreadySubscribed: false,
  setAlreadySubscribed: () => {},
  sso: true,
  setSso: () => {},
  hasCard: true,
  setHasCard: () => {}
});
export function DebugProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [alreadySubscribed, setValue] = useState(false);
  const [sso, setSsoValue] = useState(true);
  const [hasCard, setHasCardValue] = useState(true);
  const setAlreadySubscribed = useCallback((value: boolean) => setValue(value), []);
  const setSso = useCallback((value: boolean) => setSsoValue(value), []);
  const setHasCard = useCallback((value: boolean) => setHasCardValue(value), []);
  const value = useMemo(() => ({
    alreadySubscribed,
    setAlreadySubscribed,
    sso,
    setSso,
    hasCard,
    setHasCard
  }), [alreadySubscribed, setAlreadySubscribed, sso, setSso, hasCard, setHasCard]);
  return <DebugContext.Provider value={value} data-id="element-2871" data-mp="3cl4vcmagjdzg">{children}</DebugContext.Provider>;
}
export function useDebug(): DebugContextValue {
  return useContext(DebugContext);
}